import { formatDateTimePartsInGmtPlus3 } from '@/shared/date-time-gmt-plus-3';
import { Marketplace } from '@/enums/marketplace';

const numberFormat = new Intl.NumberFormat('ru-RU');
const reportChannelLabelByPlatform: Record<string, string> = {
    [Marketplace.Wb]: 'Wildberries',
    [Marketplace.Ozon]: 'Ozon',
    [Marketplace.YandexMarket]: 'Yandex Market',
};

export const formatInteger = (value: number): string => numberFormat.format(Math.max(0, Math.round(value)));

export const formatPercent = (value: number | null, fractionDigits = 1): string => {
    if (value === null || Number.isNaN(value)) {
        return '—';
    }

    return `${value.toLocaleString('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: fractionDigits,
    })}%`;
};

export const formatRating = (value: number | null): string => {
    if (value === null || Number.isNaN(value)) {
        return '—';
    }

    return value.toLocaleString('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
};

export const formatRatingWithStar = (value: number | null): string => `★ ${formatRating(value)}`;

export const formatSignedDelta = (value: number | null): string => {
    if (value === null || Number.isNaN(value)) {
        return '—';
    }

    return value.toLocaleString('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        signDisplay: 'always',
    });
};

export const trimLabel = (value: string, maxLength: number): string => {
    if (value.length <= maxLength) {
        return value;
    }

    return `${value.slice(0, Math.max(1, maxLength - 1))}…`;
};

export const formatReportChannelName = (value: string | null | undefined): string | null => {
    if (typeof value !== 'string') {
        return null;
    }

    const normalizedValue = value.trim().toLowerCase();
    if (!normalizedValue) {
        return null;
    }

    return reportChannelLabelByPlatform[normalizedValue] || value.trim();
};

export const formatDateOnlyInGmtPlus3 = (value: string): string => {
    const parts = formatDateTimePartsInGmtPlus3(value);
    if (!parts) {
        return value.slice(0, 10) || value;
    }

    return parts.date;
};

export const toIsoDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export const getDateDaysAgoIso = (days: number, now: Date = new Date()): string => {
    const date = new Date(now);
    date.setDate(date.getDate() - days);

    return toIsoDate(date);
};
